/*tslint:disabled*/
export enum ParticipantStatus {
  Participating = 'Participating',
  Attended = 'Attended',
  NotAttended = 'NotAttended'
}

export enum ParticipantMode {
  Invite = 'Invite',
  Direct = 'Direct'
}

export enum ParticipantRole {
  Organizer = 'Organizer',
  Participant = 'Participant'
}

export class ActivityParticipant {
  public participantId = 0;
  public activityId = 0;
  public userId = '';
  public fullName = '';
  public localName = '';
  public profileImageUrl = '';
  public participantStatus: ParticipantStatus = null;
  public participantMode: ParticipantMode = null;
  public participantRole: ParticipantRole = null;
  public joinedOn: Date | any = null;
  public membershipType = '';
  public insertedBy = '';
  public insertedOn: Date | any = null;
  public updatedBy = '';
  public updatedOn: Date | any = null;

  constructor(defaults?: any) {
    if (defaults) {
      Object.keys(defaults).forEach(key => {
        if (this.hasOwnProperty(key)) {
          this[key] = defaults[key];
        }
      });
    }
  }
}
